import React, { lazy } from "react";

const LazyTasks = lazy(() => import("./Tasks"));

const Tasks = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => <LazyTasks {...props} />;

export default Tasks;
